async function l(e, t, i) {
  if (e === null)
    return i();
  let n = t.get(e);
  return n || (n = i().finally(() => t.delete(e)), t.set(e, n)), n;
}
export {
  l as dedupePromise
};
